export const SurveyData = {
  questions: [
    {
      id: "section-1",
      sectionInfo: true,
      title: "",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-blue-500 inline-block'>1</span> Governance & Strategic Focus",
      description:
        "Governance can be defined as the way an organization formulates its structures and implements policies guiding the conduct of its mission and the attainment of its goals. A well governed organization is an effective organization. Basic principles of effective governance include an accountable governing body, acting as the highest authority, and leading the organization towards achieving its mission; and a clearly sense of purpose as stated in its vision, mission, goals and strategic plan.",
    },
    {
      id: "section-2",
      sectionInfo: true,
      title: "",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-blue-500 inline-block'>1.1</span> Governing Body ",
      description:
        "Governing Body means the organizational structure that has ultimate authority and accountability for the association. This may be called a Board of Directors, Executive Counsel, Executive Committee, Governing Body, or some other name.",
    },

    {
      id: "question-1",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-blue-500 inline-block'>1.1.1</span> The association is a properly registered entity according to local applicable regulations. The governing body is structured and selected in compliance with these legal requirements and has a clearly documented terms of reference. The length of tenure of governing body members is respected as outlined in the association’s bylaws.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-blue-500 inline-block'>1.</span> Governance & Strategic Focus / <span class='rounded-full text-lg text-white px-6 bg-blue-500 inline-block'>1.1</span>	Governing Body",
      description: "Q1",
      sectionId: "1",
      subSectionId: "1.1",
    },
    {
      id: "question-2",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-blue-500 inline-block'>1.1.2</span> The governing body performs its role to provide overall policy direction and oversight for the association and directing the activities of the association. The governing body also provides financial accountability and financial oversight of the association.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-blue-500 inline-block'>1.</span> Governance & Strategic Focus / <span class='rounded-full text-lg text-white px-6 bg-blue-500 inline-block'>1.1</span>	Governing Body",
      description: "Q2",
      sectionId: "1",
      subSectionId: "1.1",
    },
    {
      id: "question-3",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-blue-500 inline-block'>1.1.3</span> The governing body fulfills its fundraising role (e.g. assists in resource mobilization for the activities of the association) and its lobbying role (e.g. promotes the activities of the association and advocates for strengthened biosafety to stakeholders).",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-blue-500 inline-block'>1.</span> Governance & Strategic Focus / <span class='rounded-full text-lg text-white px-6 bg-blue-500 inline-block'>1.1</span>	Governing Body",
      description: "Q3",
      sectionId: "1",
      subSectionId: "1.1",
    },
    {
      id: "question-4",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-blue-500 inline-block'>1.1.4</span> The governing body is composed of committed leaders who represent the varied interests of the members and stakeholders. These leaders have the skills, knowledge and experience to carry out their roles effectively.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-blue-500 inline-block'>1.</span> Governance & Strategic Focus / <span class='rounded-full text-lg text-white px-6 bg-blue-500 inline-block'>1.1</span>	Governing Body",
      description: "Q4",
      sectionId: "1",
      subSectionId: "1.1",
    },
    {
      id: "question-5",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-blue-500 inline-block'>1.1.5</span> At least 70% of the governing body members attend all association and governing body meetings. All records of decisions made by the governing body are documented and retained by the association.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-blue-500 inline-block'>1.</span> Governance & Strategic Focus / <span class='rounded-full text-lg text-white px-6 bg-blue-500 inline-block'>1.1</span>	Governing Body",
      description: "Q5",
      sectionId: "1",
      subSectionId: "1.1",
    },

    {
      id: "question-6",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-blue-500 inline-block'>1.2.1</span> The association has a clearly articulated vision, mission statement and goals. The mission and goals are communicated to and understood by the members and stakeholders.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-blue-500 inline-block'>1.</span> Governance & Strategic Focus / <span class='rounded-full text-lg text-white px-6 bg-blue-500 inline-block'>1.2</span>	Mission and Goals",
      description: "Q6",
      sectionId: "1",
      subSectionId: "1.2",
    },

    {
      id: "question-7",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-blue-500 inline-block'>1.2.2</span>The association has the necessary sectoral expertise (e.g. biosafety, biosecurity, biorisk management, biocontainment) to accomplish its mission.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-blue-500 inline-block'>1.</span> Governance & Strategic Focus / <span class='rounded-full text-lg text-white px-6 bg-blue-500 inline-block'>1.2</span>	Mission and Goals",
      description: "Q6",
      sectionId: "1",
      subSectionId: "1.2",
    },

    {
      id: "question-8",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-blue-500 inline-block'>1.2.3</span>	The association has a written strategic plan which is realistically achievable and aligned with its mission and goals. The strategic plan includes clearly articulated SMART objectives (specific, measurable, achievable, results-focused, time-bound) and is developed by the governing body with input from the members and stakeholders.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-blue-500 inline-block'>1.</span> Governance & Strategic Focus / <span class='rounded-full text-lg text-white px-6 bg-blue-500 inline-block'>1.2</span>	Mission and Goals",
      description: "Q6",
      sectionId: "1",
      subSectionId: "1.2",
    },

    {
      id: "question-9",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-blue-500 inline-block'>1.2.4</span> The development of the mission, goals and objectives, and the strategic planning process, is based on analysis of the external environment (e.g. political context, meeting the needs of external stakeholders, economical factors, relevance, impact) and the internal environment (e.g. meeting the needs of membership, association’s governance structure & strategic leadership, internal human and financial resources). Programs are regularly reviewed and adapted to the changing needs of its members and stakeholders.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-blue-500 inline-block'>1.</span> Governance & Strategic Focus / <span class='rounded-full text-lg text-white px-6 bg-blue-500 inline-block'>1.2</span>	Mission and Goals",
      description: "Q6",
      sectionId: "1",
      subSectionId: "1.2",
    },

    {
      id: "question-10",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-blue-500 inline-block'>1.2.5</span> The association uses performance indicators to measure progress towards the achievement of its mission and the impact of its activities. The results of these evaluations are used to make adjustments to the association’s activities. Activities are also adapted based on the changing needs of its members and stakeholders.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-blue-500 inline-block'>1.</span> Governance & Strategic Focus / <span class='rounded-full text-lg text-white px-6 bg-blue-500 inline-block'>1.2</span>	Mission and Goals",
      description: "Q6",
      sectionId: "1",
      subSectionId: "1.2",
    },

    {
      id: "section-3",
      sectionInfo: true,
      title: "",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2</span> Management & Administration",
      description:
        "The management and administration of an association’s day-to-day operations greatly influence the ability of the association to carry out its mission and goals. A well-managed association has an operational structure with clearly defined roles and responsibilities (e.g. management, secretariat, staff, committees, volunteers); develops and implements work plans and activities reflecting a broader strategic plan; plans for and allocates resources properly; adheres to clearly defined administrative procedures; regularly reports on activities to members and stakeholders; and, places value on human resources with formalized personnel practices.",
    },

    {
      id: "question-11",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.1.1</span>	The association has a defined operational structure to carry out the organization’s day-to-day activities (e.g. management, secretariat, staff, volunteers, committees) with clear lines of authority and responsibility. The structure is defined within the association’s bylaws and policies.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.</span> Management & Administration / <span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.1</span>	Operational Structure & Administration",
      description: "Q6",
      sectionId: "2",
      subSectionId: "2.1",
    },

    {
      id: "question-12",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.1.2</span>	The association’s operational structure is realistic and provides an adequate framework for carrying out the mission and goals of the organisation.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.</span> Management & Administration / <span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.1</span>	Operational Structure & Administration",
      description: "Q6",
      sectionId: "2",
      subSectionId: "2.1",
    },

    {
      id: "question-13",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.1.3</span> Each of the positions within the operational structure are filled (i.e. either by staff or volunteers). Individuals are drawn from a diverse background, are free from conflict of interest, bring to the association a wide range of skills and experience, and are capable of collaborating across the entire organization.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.</span> Management & Administration / <span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.1</span>	Operational Structure & Administration",
      description: "Q6",
      sectionId: "2",
      subSectionId: "2.1",
    },

    {
      id: "question-14",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.1.4</span> Written administrative procedures (e.g. day-to-day operations, human resources, document control, travel, financial management) have been developed and are adhered to. These procedures are regularly reviewed and updated as required.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.</span> Management & Administration / <span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.1</span>	Operational Structure & Administration",
      description: "Q6",
      sectionId: "2",
      subSectionId: "2.1",
    },

    {
      id: "question-15",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.1.5</span> Administrative procedures include risk management activities to protect the association (e.g. external audits of the association’s operations, inventory-taking).",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.</span> Management & Administration / <span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.1</span>	Operational Structure & Administration",
      description: "Q6",
      sectionId: "2",
      subSectionId: "2.1",
    },

    {
      id: "question-16",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.2.1</span> The association’s operational work plans reflect the strategic plan and include specific activities, accountabilities, budgets, time frames for implementation, monitoring and evaluation.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.</span> Management & Administration / <span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.2</span>	Operational Planning & Reporting",
      description: "Q6",
      sectionId: "2",
      subSectionId: "2.2",
    },

    {
      id: "question-17",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.2.2</span> Work plans and activities are jointly developed by the appropriate members and stakeholders.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.</span> Management & Administration / <span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.2</span>	Operational Planning & Reporting",
      description: "Q6",
      sectionId: "2",
      subSectionId: "2.2",
    },

    {
      id: "question-18",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.2.3</span> Resources (human and financial) to implement the association’s work plans are planned for and allocated properly.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.</span> Management & Administration / <span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.2</span>	Operational Planning & Reporting",
      description: "Q6",
      sectionId: "2",
      subSectionId: "2.2",
    },

    {
      id: "question-19",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.2.4</span> Work plans are reviewed regularly and updated when necessary. Flexibility exists to adjust work plans and activities as a result of the monitoring process.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.</span> Management & Administration / <span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.2</span>	Operational Planning & Reporting",
      description: "Q6",
      sectionId: "2",
      subSectionId: "2.2",
    },

    {
      id: "question-20",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.2.5</span> The association produces quality activity and evaluation reports which are distributed to its members and stakeholders.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.</span> Management & Administration / <span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.2</span>	Operational Planning & Reporting",
      description: "Q6",
      sectionId: "2",
      subSectionId: "2.2",
    },

    {
      id: "question-21",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.3.1</span> Written procedures and criteria are in place for the selection of staff, volunteers, committee members and other individuals within the association’s operational structure. The diversity of the association’s membership is reflected in these human resources.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.</span> Management & Administration / <span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.3</span>	Managing Human Resources",
      description: "Q6",
      sectionId: "2",
      subSectionId: "2.3",
    },

    {
      id: "question-22",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.3.2</span> Individuals are provided with the tools and training necessary to carry out responsibilities based on the association’s capacity needs to carry out program objectives. Individuals with financial responsibilities have the skills and qualifications needed to oversee financial responsibilities for the association.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.</span> Management & Administration / <span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.3</span>	Managing Human Resources",
      description: "Q6",
      sectionId: "2",
      subSectionId: "2.3",
    },

    {
      id: "question-23",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.3.3</span> Individuals participate in decisions on how their own work is organized and know what is expected of them. Teamwork is encouraged, communication is open, and information is shared freely among all individuals.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.</span> Management & Administration / <span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.3</span>	Managing Human Resources",
      description: "Q6",
      sectionId: "2",
      subSectionId: "2.3",
    },

    {
      id: "question-24",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.3.4</span> The association provides incentives, either financial (e.g. competitive salaries, benefits) or non-financial (e.g. special projects, assignments, acquiring and using new skills, continual learning and career development), to maintain motivation and the full potential of its human resources.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.</span> Management & Administration / <span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.3</span>	Managing Human Resources",
      description: "Q6",
      sectionId: "2",
      subSectionId: "2.3",
    },

    {
      id: "question-25",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.3.5</span> The performance of individuals is monitored, evaluated and feedback given. Performance recognition schemes, and grievances/conflict resolution procedures are in place.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.</span> Management & Administration / <span class='rounded-full text-lg text-white px-6 bg-red-700 inline-block'>2.3</span>	Managing Human Resources",
      description: "Q6",
      sectionId: "2",
      subSectionId: "2.3",
    },

    {
      id: "section-4",
      sectionInfo: true,
      title: "",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3</span> Financial Resources",
      description:
        "The governing body has overall responsibility for financial stewardship and ensuring appropriate procedures and systems are in place for managing the association’s financial resources. Good financial management is not only concerned with the raising and allocation of funds to attain the association’s goals, but also addresses the way in which funds are used for the purpose intended. It not sufficient to be able to access funds – associations must spend their financial resources wisely on relevant activities that are aligned with their strategic goals and objectives. Unrestricted funds are also available to cover fundament core costs and overhead expenses. Equally important are accurate financial accounting procedures, transparency, auditing and reporting. The association’s accounting system and financial controls should be aligned with internationally accepted accounting standards and best practices. Finally, financially sustainable associations have a diversified income base including income generating activities and are able to mobilize and efficiently manage resources without excessive dependence on any single funding source or revenue generating stream.",
    },

    {
      id: "question-26",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.1.1</span> The association has a diversified income without excessive dependence on any single funding source or revenue generating stream.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.</span> Financial Resources / <span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.1</span>	Generating Income & Fundraising",
      description: "Q6",
      sectionId: "3",
      subSectionId: "3.1",
    },

    {
      id: "question-27",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.1.2</span> The association generates its own income in addition to membership fees through fee-for-services or other cost recovery mechanisms.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.</span> Financial Resources / <span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.1</span>	Generating Income & Fundraising",
      description: "Q6",
      sectionId: "3",
      subSectionId: "3.1",
    },

    {
      id: "question-28",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.1.3</span> The association has a realistic fundraising strategy to access a variety of additional resources such as in-kind contributions and donations.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.</span> Financial Resources / <span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.1</span>	Generating Income & Fundraising",
      description: "Q6",
      sectionId: "3",
      subSectionId: "3.1",
    },

    {
      id: "question-29",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.1.4</span> The association has funds for short-term expenses (e.g. for next 3 months) and a long-term resource mobilization plan. There is a policy for financial reserves to enable the association to meet its mission in periods when funds are not forthcoming.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.</span> Financial Resources / <span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.1</span>	Generating Income & Fundraising",
      description: "Q6",
      sectionId: "3",
      subSectionId: "3.1",
    },

    {
      id: "question-30",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.2.1</span> An individual with training in financial accounting/bookkeeping is responsible for the association’s accounting procedures. These procedures follows sound financial accounting practices using internationally accepted financial tools (delegation of authority, accounting software to process and record financial transactions, Chart of Accounts, reconciliation of bank statements, cash books, receipt books, invoices, fixed asset register). A supporting document is available for every income and expenditure transaction.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.</span> Financial Resources / <span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.2</span>	Accounting & Controls",
      description: "Q6",
      sectionId: "3",
      subSectionId: "3.2",
    },

    {
      id: "question-31",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.2.2</span> Account categories (e.g. cost centers) exist for separating individual project funds and to avoid cross-project funding. The association is able to track core overhead and operational costs separately from project funds.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.</span> Financial Resources / <span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.2</span>	Accounting & Controls",
      description: "Q6",
      sectionId: "3",
      subSectionId: "3.2",
    },

    {
      id: "question-32",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.2.3</span> Sound procurement processes are in place and followed. The association verifies that goods and services bought by the association have been received before invoices are paid. Salaries are paid after substantiation of the activities performed and hours accumulated (e.g. time-sheets).",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.</span> Financial Resources / <span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.2</span>	Accounting & Controls",
      description: "Q6",
      sectionId: "3",
      subSectionId: "3.2",
    },

    {
      id: "question-33",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.2.4</span> Internal financial controls are in place to provide assurances that assets are safeguarded, have been accurately presented in the financial statements and that local laws and regulations have been observed (e.g. petty cash locked in cash box or safe, bank accounts in the name of the association, transactions authorized, cheques not signed before the payee is written in and supporting documents verified, supporting documents and bank statements are kept on file.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.</span> Financial Resources / <span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.2</span>	Accounting & Controls",
      description: "Q6",
      sectionId: "3",
      subSectionId: "3.2",
    },

    {
      id: "question-34",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.2.5</span> An annual external financial audit is conducted by a qualified independent individual. Auditors are not selected by individuals with financial responsibility within the association. Recommendations from the auditor (e.g. to correct any weaknesses in financial control, suggestions to improve financial management practices) are implemented.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.</span> Financial Resources / <span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.2</span>	Accounting & Controls",
      description: "Q6",
      sectionId: "3",
      subSectionId: "3.2",
    },

    {
      id: "question-35",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.3.1</span> An individual(s) with experience in financial management is responsible for the preparation, management and implementation of the budget. Budgets are approved by the governing body of the association.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.</span> Financial Resources / <span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.3</span>	Budgeting",
      description: "Q6",
      sectionId: "3",
      subSectionId: "3.3",
    },

    {
      id: "question-36",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.3.2</span> The budgeting process is integrated into the development of annual work plans and activities. Budgets are prepared for the association as whole and for individual projects as may be required. Budgets include forecasts for income, expenditures and cash flow. To facilitate planning and identify in advance areas where risks may lay, budgets separately consider the flow of restricted funds (e.g. for specific projects) and unrestricted funds (e.g. for overhead expenses).",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.</span> Financial Resources / <span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.3</span>	Budgeting",
      description: "Q6",
      sectionId: "3",
      subSectionId: "3.3",
    },

    {
      id: "question-37",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.3.3</span> The budget forecast includes enough income to pay for planned expenditures with flexibility for adjustments due to changes in circumstances. An approval process is in place for planned variations and changes to the budget.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.</span> Financial Resources / <span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.3</span>	Budgeting",
      description: "Q6",
      sectionId: "3",
      subSectionId: "3.3",
    },

    {
      id: "question-38",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.3.4</span> Actual expenses are regularly monitored against the budget and variances are investigated. The governing body receives regular budget monitoring reports showing actual versus budgeted expenditure with notes explaining the variances.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.</span> Financial Resources / <span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.3</span>	Budgeting",
      description: "Q6",
      sectionId: "3",
      subSectionId: "3.3",
    },

    {
      id: "question-39",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.4.1</span> Financial reports are presented to the governing body and include a balance sheet (i.e. summarizing assets, liabilities and net assets) and an income/expense statement (i.e. showing income minus expenses, resulting in either a surplus or deficit).",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.</span> Financial Resources / <span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.4</span>	Financial Reporting",
      description: "Q6",
      sectionId: "3",
      subSectionId: "3.4",
    },

    {
      id: "question-40",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.4.2</span> Real-time statements of cash flow and functional expenses are prepared to facilitate short-term planning and anticipate any shortfalls.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.</span> Financial Resources / <span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.4</span>	Financial Reporting",
      description: "Q6",
      sectionId: "3",
      subSectionId: "3.4",
    },

    {
      id: "question-41",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.4.3</span> The association understands what other financial reports are required (e.g. financial reports to donors and funding agencies). Such reports are prepared in the proper format and submitted to the donor within the allocated reporting period.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.</span> Financial Resources / <span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.4</span>	Financial Reporting",
      description: "Q6",
      sectionId: "3",
      subSectionId: "3.4",
    },

    {
      id: "question-42",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.4.4</span> All financial reports are used by the association for review purposes and for long-term planning.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.</span> Financial Resources / <span class='rounded-full text-lg text-white px-6 bg-green-700 inline-block'>3.4</span>	Financial Reporting",
      description: "Q6",
      sectionId: "3",
      subSectionId: "3.4",
    },

    {
      id: "section-5",
      sectionInfo: true,
      title: "",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4</span> Stakeholder Relations & Service Delivery",
      description:
        "The association’s relationships with its members and stakeholders will determine whether or not the association’s mission and goals are realized. Members and stakeholders must be supportive of what the association is intent on accomplishing and the association-stakeholder relationship is one of partnership for a common purpose. A fully involved and motivated membership, stakeholders who see the association as having value and impact, and a positive image within the local community, will lead to a more sustainable organization. Finally, in order for the association to remain sustainable, it must adapt to a changing context and continue to be relevant to its members and stakeholders over time.",
    },

    {
      id: "question-43",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.1.1</span> The organization’s membership is drawn from a variety of stakeholders (e.g. diagnostic & research laboratories, scientific institutions, governments, academia, private industry, non-governmental organizations).",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.</span> Stakeholder Relations & Service Delivery / <span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.1</span>	Member Relations",
      description: "Q6",
      sectionId: "4",
      subSectionId: "4.1",
    },

    {
      id: "question-44",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.1.2</span> The association’s members are involved in the activities of the association, motivated and committed to success of the organization. ",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.</span> Stakeholder Relations & Service Delivery / <span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.1</span>	Member Relations",
      description: "Q6",
      sectionId: "4",
      subSectionId: "4.1",
    },

    {
      id: "question-45",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.1.3</span> The culture operating within the association’s membership, and between the membership and governing body, is participatory and consensus building working towards a common goal.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.</span> Stakeholder Relations & Service Delivery / <span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.1</span>	Member Relations",
      description: "Q6",
      sectionId: "4",
      subSectionId: "4.1",
    },

    {
      id: "question-46",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.1.4</span> There is effective and ongoing communication from the governing body to the members. There is a mechanism for members to communicate with the governing body and provide input into the organization’s goals and strategic plans.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.</span> Stakeholder Relations & Service Delivery / <span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.1</span>	Member Relations",
      description: "Q6",
      sectionId: "4",
      subSectionId: "4.1",
    },

    {
      id: "question-47",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.1.5</span> The members regularly attend the association’s meetings, conferences and events. If applicable, membership fees are paid by the members annually, or, as may be required by the association’s bylaws.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.</span> Stakeholder Relations & Service Delivery / <span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.1</span>	Member Relations",
      description: "Q6",
      sectionId: "4",
      subSectionId: "4.1",
    },

    {
      id: "question-48",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.2.1</span> The association has established relationships with a variety of stakeholders (e.g. governments, research institutes, laboratories, academia, private sector, NGOs, donors, funding agencies, international agencies) and is recognized as a credible and valuable resource.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.</span> Stakeholder Relations & Service Delivery / <span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.2</span> Stakeholder Relations",
      description: "Q6",
      sectionId: "4",
      subSectionId: "4.2",
    },

    {
      id: "question-49",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.2.2</span> The biosafety expertise and services provided by the association to its stakeholders is highly relevant and beneficial. The association-stakeholder relationship is one of partnership for a common purpose.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.</span> Stakeholder Relations & Service Delivery / <span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.2</span> Stakeholder Relations",
      description: "Q6",
      sectionId: "4",
      subSectionId: "4.2",
    },

    {
      id: "question-50",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.2.3</span> The association engages in dialogue with policy-makers and is called upon by governments to collaborate on biosafety issues.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.</span> Stakeholder Relations & Service Delivery / <span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.2</span> Stakeholder Relations",
      description: "Q6",
      sectionId: "4",
      subSectionId: "4.2",
    },

    {
      id: "question-51",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.2.4</span> The association has a relationship with the private sector for technical expertise, materials, in-kind contributions, and/or human and financial resources.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.</span> Stakeholder Relations & Service Delivery / <span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.2</span> Stakeholder Relations",
      description: "Q6",
      sectionId: "4",
      subSectionId: "4.2",
    },

    {
      id: "question-52",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.2.5</span> The association collaborates with and shares resources among other national, regional and international biosafety associations.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.</span> Stakeholder Relations & Service Delivery / <span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.2</span> Stakeholder Relations",
      description: "Q6",
      sectionId: "4",
      subSectionId: "4.2",
    },

    {
      id: "question-53",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.3.1</span> The association engages in public relations and has a positive image among the local community and public. The association’s mission and goals is understood and seen as having value.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.</span> Stakeholder Relations & Service Delivery / <span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.3</span> Public Relations & Media",
      description: "Q6",
      sectionId: "4",
      subSectionId: "4.3",
    },

    {
      id: "question-54",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.3.2</span> The association has a strategy for and regularly engages with the media. The association has received positive media attention. The media consults with the association on relevant issues.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.</span> Stakeholder Relations & Service Delivery / <span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.3</span> Public Relations & Media",
      description: "Q6",
      sectionId: "4",
      subSectionId: "4.3",
    },

    {
      id: "question-55",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.3.3</span> The association has a marketing plan to build brand awareness and position itself as a source of biosafety expertise.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.</span> Stakeholder Relations & Service Delivery / <span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.3</span> Public Relations & Media",
      description: "Q6",
      sectionId: "4",
      subSectionId: "4.3",
    },

    {
      id: "question-56",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.4.1</span> The association’s activities are supported by the members & stakeholders. They recognize the benefits of, and are involved in, the work of the association.",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.</span> Stakeholder Relations & Service Delivery / <span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.4</span> Service Delivery & Benefit",
      description: "Q6",
      sectionId: "4",
      subSectionId: "4.4",
    },

    {
      id: "question-57",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.4.2</span> The association is providing biosafety capacity building and skills-transfer to local stakeholders (e.g. training, technical assistance).",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.</span> Stakeholder Relations & Service Delivery / <span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.4</span> Service Delivery & Benefit",
      description: "Q6",
      sectionId: "4",
      subSectionId: "4.4",
    },

    {
      id: "question-58",
      title:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.4.3</span> The association plans and adapts its activities in accordance with changes in the local stakeholder environment (e.g. increased awareness of biosafety, strengthened biosafety practices).",
      sectionHeader:
        "<span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.</span> Stakeholder Relations & Service Delivery / <span class='rounded-full text-lg text-white px-6 bg-purple-600 inline-block'>4.4</span> Service Delivery & Benefit",
      description: "Q6",
      sectionId: "4",
      subSectionId: "4.4",
    },
  ],
};
